// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { xScreen } from "@guestsupply/XDL/Utilities";
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

listStyles;

listStyles.wrapper = {
    css: css`
        margin: ${({ isListView }: any) => (isListView ? "20px 0 0" : "20px 0 13px")};
        border-bottom: 1px solid ${getColor("common.border")};
        border-bottom-width: ${({ isListView }: any) => (isListView ? "0" : "1px")};
        padding-bottom: 24px;

        ${xScreen("lte", "md")} {
            margin: 10px 0 0;
        }
    `,
};
listStyles.cardList = {
    gridContainer: {
        gap: 22,
    },
};
listStyles.centeringWrapper = {
    css: css`
        width: 100%;
        height: 300px;
        display: flex;
        align-items: baseline;
        & > span {
            max-width: unset;
        }
    `,
};
listStyles.spinner = {
    css: css`
        margin: auto;
    `,
};
listStyles.noProductsText = {
    variant: "h4",
    css: css`
        display: block;
        margin: auto;
    `,
};
listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            border: initial;
        `,
    },
    gridItem: {
        css: css`
            padding: 0 11px;
            ${xScreen("lte", "sm")} {
                padding: 11px;
            }
        `,
    },
};
